(function () {
  const container = document.querySelector('.bundle-cards');
  if (!container) return;

  const sectionId = container.dataset.sectionId;
  const basePrice = parseInt(container.dataset.basePrice, 10);
  const variants = JSON.parse(container.querySelector('[data-bundle-variants]').textContent);
  const colorsData = container.querySelector('[data-bundle-colors]');
  const optionsData = JSON.parse(container.querySelector('[data-bundle-product-options]').textContent);
  const colorOptionIndex = optionsData.color_option_index;

  const cards = container.querySelectorAll('.bundle-card');
  const discounts = { 1: 0, 2: 0.15, 4: 0.25 };

  // Find variant ID by color name
  function findVariantByColor(colorName) {
    if (colorOptionIndex === null) return variants[0];
    return variants.find(function (v) {
      return v.options[colorOptionIndex] === colorName && v.available;
    }) || variants.find(function (v) {
      return v.options[colorOptionIndex] === colorName;
    });
  }

  // Get currently selected color from the main variant picker (or scent switcher)
  function getSelectedColor() {
    const scent = document.querySelector('input[name="koji_scent"]:checked');
    if (scent && scent.dataset.color) return scent.dataset.color;

    const variantSelects = document.getElementById('variant-selects-' + sectionId);
    if (!variantSelects) return null;
    const checked = variantSelects.querySelector('input[type="radio"]:checked');
    if (checked) return checked.value;
    const select = variantSelects.querySelector('select');
    if (select) return select.value;
    return null;
  }

  // Initialize: set first slot of each card to current selected color
  function initSlots() {
    const selectedColor = getSelectedColor();
    cards.forEach(function (card) {
      const slots = card.querySelectorAll('.bundle-slot');
      slots.forEach(function (slot, idx) {
        const swatches = slot.querySelectorAll('.bundle-swatch');
        let hasActive = false;

        swatches.forEach(function (sw) {
          sw.classList.remove('bundle-swatch--active');
          if (idx === 0 && selectedColor && sw.dataset.color === selectedColor) {
            sw.classList.add('bundle-swatch--active');
            hasActive = true;
          }
        });

        // Default to first swatch if none matched
        if (!hasActive && swatches.length > 0) {
          swatches[0].classList.add('bundle-swatch--active');
        }
      });
    });
  }

  // Card selection
  cards.forEach(function (card) {
    card.addEventListener('click', function (e) {
      // Don't toggle card when clicking a swatch
      if (e.target.closest('.bundle-swatch')) return;

      cards.forEach(function (c) { c.classList.remove('bundle-card--active'); });
      card.classList.add('bundle-card--active');
      card.querySelector('input[type="radio"]').checked = true;
    });
  });

  // Push a slot-0 choice back up to the main variant picker, so the price,
  // gallery and the single-item add-to-cart path all follow the first slot.
  function syncPickerFromSlot(value) {
    // Scent switcher (sister products) takes precedence over a variant picker
    const scentRadios = document.querySelectorAll('input[name="koji_scent"]');
    if (scentRadios.length) {
      scentRadios.forEach(function (r) {
        if (r.dataset.color === value && !r.checked) r.click();
      });
      return;
    }

    const variantSelects = document.getElementById('variant-selects-' + sectionId);
    if (!variantSelects) return;

    const input = variantSelects.querySelector(
      'input[type="radio"][value="' + CSS.escape(value) + '"]'
    );
    if (input) {
      if (!input.checked) input.click();
      return;
    }

    const select = variantSelects.querySelector('select');
    if (select && select.value !== value) {
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // Swatch selection within slots
  container.addEventListener('click', function (e) {
    const swatch = e.target.closest('.bundle-swatch');
    if (!swatch) return;

    const slot = swatch.closest('.bundle-slot');
    slot.querySelectorAll('.bundle-swatch').forEach(function (sw) {
      sw.classList.remove('bundle-swatch--active');
    });
    swatch.classList.add('bundle-swatch--active');

    if (slot.dataset.slot === '0' && swatch.dataset.color) {
      syncPickerFromSlot(swatch.dataset.color);
    }
  });

  // Listen for main variant picker changes to sync slot 0
  subscribe(PUB_SUB_EVENTS.variantChange, function (data) {
    if (data.sectionId !== sectionId) return;
    const newVariant = data.variant;
    if (!newVariant || colorOptionIndex === null) return;

    const newColor = newVariant.options[colorOptionIndex];
    cards.forEach(function (card) {
      const firstSlot = card.querySelector('.bundle-slot[data-slot="0"]');
      if (!firstSlot) return;
      firstSlot.querySelectorAll('.bundle-swatch').forEach(function (sw) {
        sw.classList.remove('bundle-swatch--active');
        if (sw.dataset.color === newColor) {
          sw.classList.add('bundle-swatch--active');
        }
      });
    });

    // Update prices based on new variant price
    updatePrices(newVariant.price);
  });

  // Scent switcher changed: mirror it into slot 0 and refresh totals
  document.addEventListener('koji:scentchange', function (e) {
    if (!e.detail || e.detail.sectionId !== sectionId) return;
    cards.forEach(function (card) {
      const firstSlot = card.querySelector('.bundle-slot[data-slot="0"]');
      if (!firstSlot) return;
      firstSlot.querySelectorAll('.bundle-swatch').forEach(function (sw) {
        sw.classList.toggle('bundle-swatch--active', sw.dataset.color === e.detail.name);
      });
    });
    if (typeof e.detail.price === 'number') updatePrices(e.detail.price);
  });

  // Per-card discount: `data-bundle-discount` (percent) wins, else the qty map.
  function discountFor(card, qty) {
    if (card.dataset.bundleDiscount !== undefined) {
      return (parseFloat(card.dataset.bundleDiscount) || 0) / 100;
    }
    return discounts[qty] || 0;
  }

  function updatePrices(price) {
    cards.forEach(function (card) {
      var qty = parseInt(card.dataset.bundleQty, 10);
      var discount = discountFor(card, qty);
      var discountedTotal = Math.round(price * (1 - discount)) * qty;
      var totalEl = card.querySelector('[data-bundle-total]');
      if (totalEl) {
        totalEl.textContent = formatMoney(discountedTotal);
      }
      var originalEl = card.querySelector('.bundle-card__price-original');
      if (originalEl) {
        originalEl.textContent = formatMoney(price * qty);
      }
    });
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    // Use Shopify's money format if available
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return amount + ' ' + window.Shopify.currency.active;
    }
    return amount + ' RON';
  }

  // Intercept product form submission for bundles > 1
  function interceptForm() {
    var productForm = document.querySelector('product-form[data-section-id="' + sectionId + '"]');
    if (!productForm) return;

    var form = productForm.querySelector('form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      var selectedRadio = container.querySelector('input[name="bundle_qty"]:checked');
      var qty = selectedRadio ? parseInt(selectedRadio.value, 10) : 1;

      if (qty <= 1) return; // Normal form behavior for single item

      e.preventDefault();
      e.stopImmediatePropagation();

      var submitButton = productForm.querySelector('[type="submit"]');
      var spinner = productForm.querySelector('.loading__spinner');

      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.classList.add('loading');
      if (spinner) spinner.classList.remove('hidden');

      // Build items array from selected swatches
      var activeCard = container.querySelector('.bundle-card--active');
      var slots = activeCard.querySelectorAll('.bundle-slot');
      var items = [];

      slots.forEach(function (slot) {
        var activeSwatch = slot.querySelector('.bundle-swatch--active');
        if (!activeSwatch) return;

        var colorName = activeSwatch.dataset.color;
        var variant = activeSwatch.dataset.variantId
          ? { id: parseInt(activeSwatch.dataset.variantId, 10) }
          : findVariantByColor(colorName);
        if (!variant) return;

        // Check if we already have this variant in items
        var existing = items.find(function (item) { return item.id === variant.id; });
        if (existing) {
          existing.quantity += 1;
        } else {
          items.push({ id: variant.id, quantity: 1 });
        }
      });

      if (items.length === 0) {
        submitButton.removeAttribute('aria-disabled');
        submitButton.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
        return;
      }

      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var body = { items: items };

      if (cart) {
        body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
        cart.setActiveElement(document.activeElement);
      }

      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(body)
      })
        .then(function (response) { return response.json(); })
        .then(function (response) {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              errors: response.errors || response.description,
              message: response.message,
            });
            return;
          }

          if (!cart) {
            window.location = window.routes.cart_url;
            return;
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            cartData: response,
          });

          cart.renderContents(response);
        })
        .catch(function (err) {
          console.error('Bundle add to cart error:', err);
        })
        .finally(function () {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          if (spinner) spinner.classList.add('hidden');
        });
    }, true); // useCapture to fire before product-form's handler
  }

  initSlots();
  interceptForm();
})();
